import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var ChunkPipe = (function () {
    function ChunkPipe() {
    }
    ChunkPipe.prototype.transform = function (input, size) {
        if (size === void 0) { size = 1; }
        if (!isArray(input)) {
            return input;
        }
        return [].concat.apply([], input.map(function (_elem, i) {
            return i % size ? [] : [input.slice(i, i + size)];
        }));
    };
    return ChunkPipe;
}());
export { ChunkPipe };
ChunkPipe.decorators = [
    { type: Pipe, args: [{
                name: 'chunk'
            },] },
];
/** @nocollapse */
ChunkPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=chunk.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/chunk.pipe.js
// module id = 227
// module chunks = 103